/* Site footer is hidden; legal links live in the sidebar (PageHeaderLayout). */
const PageFooterLayout = () => {
  return null;
};

export default PageFooterLayout;
